/**
 * Campos GraphQL declarados como `JSON` en el schema.
 *
 * OJO (causa de bugs reales): el escalar `JSON` de Lighthouse
 * (MLL\GraphQLScalars\JSON) hace `json_encode($value)` al SERIALIZAR, así que estos
 * campos llegan al front como STRING, no como objeto/array. Consumirlos directo
 * revienta ("pattern.reduce is not a function", "details.some is not a function").
 *
 * Regla: TODO campo JSON del backend se lee con `parseJson()` antes de usarse.
 * Campos afectados hoy: play_workout_sessions.details, play_recovery_practices
 * .breathing_pattern, play_recovery_steps.pattern, organizations.wellbeing_weights.
 */

/**
 * Devuelve el valor ya parseado (o el fallback) sin importar si vino como string u objeto.
 *
 * @param {*} value       valor crudo del campo GraphQL JSON
 * @param {*} fallback    qué devolver si no hay dato o el JSON es inválido
 */
export const parseJson = (value, fallback = null) => {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value !== 'string') return value;

  try {
    const parsed = JSON.parse(value);
    return parsed === null || parsed === undefined ? fallback : parsed;
  } catch {
    return fallback;
  }
};

/** Igual que parseJson pero garantiza un ARRAY (los `.map`/`.reduce` nunca revientan). */
export const parseJsonArray = (value) => {
  const parsed = parseJson(value, []);
  return Array.isArray(parsed) ? parsed : [];
};

/** Igual que parseJson pero garantiza un OBJETO plano. */
export const parseJsonObject = (value) => {
  const parsed = parseJson(value, {});
  return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
};

/**
 * Serializa un valor para MANDARLO como argumento GraphQL de tipo `JSON`.
 *
 * El mismo escalar hace `json_decode($value)` al recibir, así que espera un STRING: si le
 * mandas el objeto/array crudo, PHP revienta ANTES de llegar al resolver (ese era el fallo
 * histórico de "Acepto y confirmo" en Términos y condiciones y el de guardar entrenamiento).
 * Idempotente: si ya viene serializado, lo deja igual.
 */
export const toJsonArg = (value) => {
  if (value === null || value === undefined) return null;
  return typeof value === 'string' ? value : JSON.stringify(value);
};

export default parseJson;
